import { render, staticRenderFns } from "./CourseStatisticUserTableDetail.vue?vue&type=template&id=7072cb10&"
import script from "./CourseStatisticUserTableDetail.vue?vue&type=script&lang=js&"
export * from "./CourseStatisticUserTableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports